// Global application constants
export const APP_CONSTANTS = {
  DEFAULT_LANGUAGE: 'lt' as const,
  SUPPORTED_LANGUAGES: ['lt', 'en'] as const,
  
  // Flag URLs - can be easily switched to local imports
  FLAGS: {
    lt: 'https://flagcdn.com/24x18/lt.png',
    en: 'https://flagcdn.com/24x18/gb.png'
  },
  
  // Language display names
  LANGUAGE_NAMES: {
    lt: 'Lietuvių',
    en: 'English'
  },
  
  // Storage keys
  STORAGE_KEYS: {
    LANGUAGE: 'selectedLanguage',
    THEME: 'selectedTheme'
  }
} as const;

// Type definitions
export type LanguageCode = keyof typeof APP_CONSTANTS.FLAGS;

// Language configuration with flags
export const LANGUAGES = [
  { code: 'lt' as const, name: APP_CONSTANTS.LANGUAGE_NAMES.lt, flag: APP_CONSTANTS.FLAGS.lt },
  { code: 'en' as const, name: APP_CONSTANTS.LANGUAGE_NAMES.en, flag: APP_CONSTANTS.FLAGS.en }
] as const;

// Helper functions
export const getFlag = (code: LanguageCode): string => {
  return APP_CONSTANTS.FLAGS[code];
};

export const getLanguage = (code: LanguageCode) => {
  return LANGUAGES.find(lang => lang.code === code);
};

// Re-export for convenience
export const { FLAGS, LANGUAGE_NAMES, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } = APP_CONSTANTS;
